import { ErrorResponse, indentstatusenum, UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { indentformDto, IndentFormItemsDto, IndentMaterialDropDownDto } from '@gtpl/shared-models/procurement-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { getManager, Raw, Repository } from 'typeorm';
import { IndentFormDto } from './dto/indent-form-for-material.dto';
import { IndentQuantityRequest, IndentRequestformaterial, RequestforIndentItem, Requestforindentstatusupdate } from './dto/indent-form-request';
import { IndentItemsDto } from './dto/indent-items.dto';
import { IndentMaterialEntity } from './indent-form-entity';
import { IndentFormAdapterFormMaterial } from './indent-form-for-material-adapter';
import { IndentItemEntity } from './indent-item-entity';
@Injectable()
export class indentFormServices{
    constructor(
      private logService:LogsService,

        @InjectRepository(IndentMaterialEntity) 
        private indentRepo: Repository<IndentMaterialEntity>,
        private indentFormAdapter :IndentFormAdapterFormMaterial,
        // private productAdapter: ProductAdapter,
        @InjectRepository(IndentItemEntity) 
        private indentItemRepo: Repository<IndentItemEntity>,
      ) { }
       /**
     * to Create or Update Store Consumption Data
     * @param Data 
     * @returns 
     */
    async getindenttDetailsWithoutRelations(id: number): Promise<IndentMaterialEntity> {
      // tslint:disable-next-line: typedef
      const response = await this.indentRepo.findOne({
          where: { indentMaterialPreparationId: Raw(alias => `indent_material_preparation_id = '${id}'`) },
      });
      if (response) {
          return response;
      } else {
          return null;
      }
  }
      async createIndentFormDetails(values: IndentFormDto, isUpdate: boolean): Promise<CommonResponse> {
        try {
          const slNo = await this.indentRepo.count()
          const indentnum ="IND" + "/" + "22-23" + "/"+"00"+Number(Number(slNo) + 1)
          values.indentCode = indentnum;
          console.log(values,'##')
            console.log(isUpdate,'67');
            if (!isUpdate) {
                const Entity = await this.getindenttDetailsWithoutRelations(values.indentMaterialPreparationId);
                if (Entity) {
                    throw new CommonResponse(false, 11104, "indent already existed");
                }
            } else {
              console.log('hi')
                const Entity = await this.getindenttDetailsWithoutRelations(values.indentMaterialPreparationId);
                if (Entity) {
                    if (Entity.indentMaterialPreparationId != values.indentMaterialPreparationId) {
                        throw new CommonResponse(false, 11104, "indent already existed");
                    }
                }
            }
            
            const convertedindentmentEntity: IndentMaterialEntity = this.indentFormAdapter.convertDtoToEntity(values, isUpdate);
            // console.log("convertedindentmentEntity");
            // console.log(convertedindentmentEntity);

            const savedindentmentEntity: IndentMaterialEntity = await this.indentRepo.save(convertedindentmentEntity);
            // console.log("savedindentmentEntity");
            // console.log(savedindentmentEntity);
            const savedindentDto: IndentFormDto = this.indentFormAdapter.convertEntityToDto(savedindentmentEntity);
            if (savedindentDto) {
                // generating resposnse
                const response = new CommonResponse(true, 1, isUpdate ? 'indent Updated Successfully' : 'indent Created Successfully', savedindentDto);
                return response;
            } else {
                throw new ErrorResponse(11106, 'indent saved but issue while transforming into DTO');
            }
        } catch (error) {
            return error;
        }
    }
    async getallindentitemDetails(req:RequestforIndentItem): Promise<CommonResponse>{
      try{
        const manager= getManager();
        const query = 'SELECT ip.received_quantity AS receivedQuantity,soi.sale_order_id AS saleOrderId,imp.indent_code AS indentCode,ip.indent_item_id AS indentItemId,imp.indent_material_preparation_id AS indentMaterialPreparationId,ip.item_sub_category_id AS itemsubcategoryId,ip.item_id AS itemId,quantity,item_name AS item,item_sub_category AS itemsubcategory FROM `erpx_dev_procurement`.`indent_item_preparation` ip LEFT JOIN `erpx_dev_masters`.`items` i ON i.item_id=ip.item_id LEFT JOIN  `erpx_dev_masters`.`item_sub_categories`ic ON ic.item_sub_category_id=ip.item_sub_category_id left join '+appSettings.procure_db+'.indent_material_preparation imp on imp.indent_material_preparation_id = ip.indent_material_preparation_id left join '+appSettings.sales_db+'.sale_order_items soi on soi.sale_order_item_id = imp.sale_order_item_id where ip.indent_material_preparation_id='+req.indentMaterialPreparationId+' ';
        const result =await manager.query(query)
        if (result) {
          return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        } else {
          return new CommonResponse(false, 1111, "Error occure")
    
        }
    
      }catch(err){
        return err;
      }

    }
    async getIndentItemDetailsById(req:RequestforIndentItem): Promise<CommonResponse>{
      try{
        const manager= getManager();
        let sandhyaBrandtems = await manager.query("SELECT GROUP_CONCAT(i.item_id) AS itemId FROM erpx_dev_masters.items i LEFT JOIN `erpx_dev_masters`.master_brands mb ON mb.master_brand_id = i.brand AND mb.brand_name IN ('Sandhya Aqua','No Brand') WHERE i.brand = mb.master_brand_id");
          let noBrandItems = await manager.query("SELECT GROUP_CONCAT(i.item_id) AS itemId FROM erpx_dev_masters.items i WHERE i.brand is null");
          console.log(sandhyaBrandtems);
          console.log(noBrandItems);
        let indentInfo = await manager.query("Select indent_against AS indentAgainst from "+appSettings.procure_db+".indent_material_preparation where indent_material_preparation_id = "+req.indentMaterialPreparationId);
        let query = "Select imp.indent_against AS indentAgainst,imp.indent_material_preparation_id AS indentMaterialPreparationId,i.indent_item_id AS indentItemId,imp.unit_id AS unitId,imp.sale_order_id AS saleOrderId,0 AS 'index',i.received_quantity AS issuedQty,ic.item_category_id AS itemCategoryId,IF(i.item_id > 0, i.item_id, 0) AS itemId,isc.item_sub_category_id AS itemSubCategoryId,isc.item_sub_category AS itemSubCategory, ic.item_category AS itemCategory, 0 AS 'packingStockTransferItemId',i.quantity AS 'requiredQty',SUM(s.physical_quantity) as availableQty, s.unit_price as unitPrice, it.item_name AS item, 0 AS locationStockInfo from "+appSettings.procure_db+".indent_item_preparation i LEFT JOIN "+appSettings.procure_db+".indent_material_preparation imp on imp.indent_material_preparation_id = i.indent_material_preparation_id LEFT JOIN "+appSettings.sales_db+".sale_order_items soi on soi.sale_order_item_id = imp.sale_order_item_id LEFT JOIN "+appSettings.masters_db+".item_sub_categories isc on isc.item_sub_category_id = i.item_sub_category_id LEFT JOIN "+appSettings.masters_db+".item_categories ic on ic.item_category_id = isc.item_category_id LEFT JOIN "+appSettings.masters_db+".items it on it.item_id = i.item_id ";
        if(indentInfo[0].indentAgainst === "SALE ORDER"){
          query = query + " LEFT JOIN "+appSettings.procure_db+".stock s on s.saleorder_id = soi.sale_order_id and s.item_sub_category_id = i.item_sub_category_id and s.item_id = i.item_id and s.physical_quantity > 0 and s.unit_id = imp.unit_id and s.location_id > 0";
        }
        else if(indentInfo[0].indentAgainst === "DUMMY"){
          query = query + " LEFT JOIN "+appSettings.procure_db+".stock s on s.saleorder_id = 0 and s.item_sub_category_id = i.item_sub_category_id and s.physical_quantity > 0 and s.location_id > 0 and (s.item_id IN ("+sandhyaBrandtems[0].itemId+") OR s.item_id IN ("+noBrandItems[0].itemId+") OR s.item_id = i.item_id)";
        }
        
        query = query + " where i.indent_material_preparation_id = "+req.indentMaterialPreparationId+" GROUP BY i.indent_item_id order by s.created_at DESC";
        const result =await manager.query(query);
        if (result.length > 0) {
          

          for (const [index, element] of result.entries()) {
            let query = "Select 0 AS indentItemId,i.item_name AS itemName, stock_id AS stockId,physical_quantity as availableQty,location_id AS locationId, rmrp.rm_rack_code AS location, 0 AS issuedQty, 0 AS requiredQty, 0 AS isChecked from "+appSettings.procure_db+".stock s left join "+appSettings.masters_db+".items i on i.item_id = s.item_id left join "+appSettings.masters_db+".rm_rack_position rmrp on rmrp.rm_rack_position_id = s.location_id where s.saleorder_id = "+element.saleOrderId+" and s.item_sub_category_id = "+element.itemSubCategoryId+" and s.physical_quantity > 0 and s.unit_id = "+element.unitId+" and s.location_id > 0";
            if(element.indentAgainst === "SALE ORDER"){
              query = query + " and s.item_id = "+element.itemId;
            }
            else if(element.indentAgainst === "DUMMY"){
              query = query + " and (s.item_id IN ("+sandhyaBrandtems[0].itemId+") OR s.item_id IN ("+noBrandItems[0].itemId+") OR s.item_id = "+element.itemId+")";
            }
            query = query + " order by s.created_at DESC";
            const data = await manager.query(query);
            let requiredQty = element.requiredQty;
            let receivedQty = element.issuedQty;
            console.log("*********"+requiredQty+"*********"+receivedQty);
            for (const [index1, element1] of data.entries()) {
              if(element1.availableQty <= requiredQty && requiredQty > 0){
                data[index1].issuedQty = Number(element1.availableQty) - Number(receivedQty)
                requiredQty = requiredQty - element1.availableQty;
              }
              else if(element1.availableQty > requiredQty && requiredQty > 0){
                data[index1].issuedQty = Number(requiredQty) - Number(receivedQty);
                requiredQty = requiredQty - requiredQty;
              }
              else{
                data[index1].issuedQty = 0;
              }
              console.log(index1)
              console.log(element1)
              data[index1].requiredQty = element.requiredQty
              data[index1].isChecked = 0;
              data[index1].indentItemId = element.indentItemId;

            }
            console.log(data);
            if(data.length> 0 ){
              result[index].locationStockInfo = data;
            }
            else{
              result[index].locationStockInfo = {};
            }
          }
          return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        } else {
          return new CommonResponse(false, 1111, "Error occure")
        }
      }catch(err){
        return err;
      }

    }
    
    async getindentformdetails(req:UnitRequest): Promise<CommonResponse>{
      try{
        const manager= getManager();
        let query = 'SELECT im.unit_id AS unitId,im.indent_against AS indentAgainst,SUM(iip.quantity) AS requiredQty,SUM(iip.received_quantity) AS receivedQty,si.sale_order_id,im.indent_material_preparation_id AS indentMaterialPreparationId,indent_code as indentCode,DATE(indent_date) AS indentDate,im.employee_id AS employeeId,im.sale_order_item_id AS saleorderItemId,po_number,sc.variant_code,CONCAT(po_number,"-",sc.variant_code) AS saleOrderItem,employee_name AS employeeName,im.is_active AS isActive,im.status AS status FROM `erpx_dev_procurement`.`indent_material_preparation` im LEFT JOIN '+appSettings.procure_db+'.indent_item_preparation iip on iip.indent_material_preparation_id = im.indent_material_preparation_id  LEFT JOIN `erpx_dev_masters`.`employee_details` ed ON im.employee_id=ed.employee_id LEFT JOIN `erpx_dev_sales`.`sale_order_items` si ON si.sale_order_item_id=im.sale_order_item_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sv ON sv.sale_order_id = si.sale_order_id LEFT JOIN erpx_dev_masters.sku_codes sc ON sc.sku_code_id = si.varient_id where im.indent_material_preparation_id >0 ';
        if(req.unitId != 5){
          query =query +'AND im.unit_id='+req.unitId+' GROUP BY im.indent_material_preparation_id'+''
        }else{
          query = query +'GROUP BY im.indent_material_preparation_id'+''
        }
        const result =await manager.query(query)
        if (result) {
          const data = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
          // const newLogDto = new LogsDto(1,'view indent for prepared material', 'IndentMaterialEntity', result.employeeId, true, '',result.createdUser)
          //   let res = await this.logService.createLog(newLogDto);
          //   console.log(res);
          return data
        } else {
          return new CommonResponse(false, 1111, "Error occure")
    
        }
    
      }catch(err){
        return err;
      }

    }
    async getAllIndentdataforindentmaterialId(req: RequestforIndentItem): Promise<CommonResponse> {
      const indentdetailsdata = await this.indentRepo.findOne({ where: { indentMaterialPreparationId: req.indentMaterialPreparationId } })
      const indentitemsdata = await this.getallindentitemDetails(req)
      const allData = { ...indentdetailsdata, ...{ indentItemDetails: indentitemsdata.data } }
      if (indentdetailsdata && indentitemsdata.status) {
          return new CommonResponse(true, 11111, 'Data retreived sucessfully', allData)
      } else {
          return new CommonResponse(false, 11111, 'No data found')
      }
  }
  async getIndentsDropDown(req:UnitRequest) : Promise<CommonResponse>{
    const response : IndentMaterialDropDownDto[] = [];
    const indentdetailsdata = await this.indentRepo.find({ where: { unitId: req.unitId, status:indentstatusenum.OPEN }});
    if (indentdetailsdata.length > 0) {
      for(const res of indentdetailsdata){
        const data = new IndentMaterialDropDownDto(res.indentMaterialPreparationId,res.indentCode);
        response.push(data);
      }
        return new CommonResponse(true, 11111, 'Data retreived sucessfully', response)
    } else {
        return new CommonResponse(false, 11111, 'No data found')
    }
}
async CancelIndentformaterialPreparation(req: Requestforindentstatusupdate): Promise<CommonResponse> {
  const response = await this.indentRepo.update({ indentMaterialPreparationId: req.indentMaterialPreparationId}, { status: req.status });
  if (response) {
      return new CommonResponse(true, 11107, 'indent cancelled updated successfully');
  } else {
      throw new ErrorResponse(11106, ' Error in Cancel of Indent ');
  }
}
async getQuantityValidationforIndent(req:IndentQuantityRequest): Promise<CommonResponse>{
  try{
    const manager= getManager();
    const query = ' SELECT b.sale_order_id,b.item_id,ROUND(b.quantity)AS bomQuantity, ROUND(IF(SUM(it.quantity) != NULL,SUM(it.quantity),0))AS indentQuantity, ROUND((b.quantity+((5/100)*b.quantity))-(IF(SUM(it.quantity) != NULL,SUM(it.quantity),0))) AS excess FROM `erpx_dev_sales`.`bom_details` b  LEFT JOIN `erpx_dev_procurement`.`indent_material_preparation` im ON im.sale_order_id=b.sale_order_id  LEFT JOIN  `erpx_dev_procurement`.`indent_item_preparation` it ON it.indent_material_preparation_id = im.indent_material_preparation_id AND it.item_id=b.item_id  WHERE b.sale_order_id='+req.saleOrderId+' AND b.item_id='+req.itemId+' GROUP BY b.sale_order_id,b.item_id';
    const result =await manager.query(query)
    if (result) {
      return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
    } else {
      return new CommonResponse(false, 1111, "Error occure")

    }

  }catch(err){
    return err;
  }

}

}